import DistributorCatalog from '@app/Distributor/Catalog'

export default function install(Vue) {
  Vue.component(DistributorCatalog.name, DistributorCatalog)
}
